import { render } from "./SuratCutiDisetujui.vue?vue&type=template&id=595213d4"
import script from "./SuratCutiDisetujui.vue?vue&type=script&lang=js"
export * from "./SuratCutiDisetujui.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__